import type { InvoiceDetailResponseDto } from '@trellis/api'

import { SendDocumentDialog } from '@/components/documents'
import {
  AlreadySentError,
  useInvoiceEmailMutation,
} from '@/hooks/useInvoiceEmail/useInvoiceEmail'
import { formatCalendarDate, getCurrencyFormatter } from '@/lib/format'

import { InvoicePreviewSheet } from './InvoicePreviewSheet'

interface SendInvoiceDialogProps {
  invoice: InvoiceDetailResponseDto
  orgName: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function SendInvoiceDialog({
  invoice,
  orgName,
  open,
  onOpenChange,
}: SendInvoiceDialogProps) {
  const mutation = useInvoiceEmailMutation(invoice.id)
  const currencyFmt = getCurrencyFormatter(invoice.currency)

  return (
    <SendDocumentDialog
      documentLabel="Invoice"
      documentNumber={invoice.invoiceNumber}
      clientEmail={
        (invoice.clientSnapshot as { email?: string | null } | null)?.email ?? ''
      }
      sentAt={invoice.sentAt}
      orgName={orgName}
      summary={
        <>
          Total due:{' '}
          <span className="text-foreground font-medium tabular-nums">
            {currencyFmt.format(invoice.total)} {invoice.currency}
          </span>
          {invoice.dueAt && (
            <>
              {' · '}Due:{' '}
              <span className="text-foreground font-medium">
                {formatCalendarDate(invoice.dueAt)}
              </span>
            </>
          )}
        </>
      }
      mutation={mutation}
      isAlreadySentError={(caughtError) => caughtError instanceof AlreadySentError}
      renderPreview={(isOpen, onPreviewOpenChange) => (
        <InvoicePreviewSheet
          invoiceId={isOpen ? invoice.id : null}
          onOpenChange={onPreviewOpenChange}
        />
      )}
      open={open}
      onOpenChange={onOpenChange}
    />
  )
}
